import { useQuery } from '@tanstack/react-query'
import pb from '@/lib/pb'
import { COLLECTIONS } from '@/types'
import type { THealthCheck } from '@/types'
import { usePbSubscription } from '@/lib/usePbSubscription'

export function useHealthChecks() {
  usePbSubscription(COLLECTIONS.HEALTH_CHECKS, ['health_checks'])
  return useQuery({
    queryKey: ['health_checks'],
    queryFn: async () => {
      // Get the latest health check per tenant
      const records = await pb.collection(COLLECTIONS.HEALTH_CHECKS).getFullList<THealthCheck>({
      })
      // Deduplicate: keep only the newest per tenant (by checked_at)
      const map = new Map<string, THealthCheck>()
      for (const r of records) {
        const existing = map.get(r.tenant)
        if (!existing || new Date(r.checked_at).getTime() > new Date(existing.checked_at).getTime()) {
          map.set(r.tenant, r)
        }
      }
      return map
    },
  })
}

export function useHealthChecksByTenant(tenantId: string) {
  usePbSubscription(COLLECTIONS.HEALTH_CHECKS, ['health_checks', tenantId])
  return useQuery({
    queryKey: ['health_checks', tenantId],
    queryFn: async () => {
      // PB defaults to ascending order. Without an explicit sort the page-1
      // window returns the OLDEST 50 records and the latest never appears.
      const records = await pb.collection(COLLECTIONS.HEALTH_CHECKS).getList<THealthCheck>(1, 50, {
        filter: `tenant = "${tenantId}"`,
        sort: '-checked_at',
      })
      return records.items
    },
    enabled: !!tenantId,
  })
}
